import React, { useEffect, useState } from 'react';
import api from '../../../connection/api';
import '../../../assets/LoginLogs.css';
import { useNavigate } from 'react-router-dom';

const LoginLogs = () => {
  const navigate = useNavigate();

    const [allLogs, setAllLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [filters, setFilters] = useState({
        username: '',
        status: '',
        start_date: '',
        end_date: ''
    });

    // Fetch all logs once
    const fetchLogs = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await api.get("/login-logs", {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            });
            setAllLogs(response.data);
            setFilteredLogs(response.data);
        } catch (err) {
            console.error("Error fetching logs", err);
        }
    };

    useEffect(() => {
        if(localStorage.getItem('role')!='superadmin')
        {
            return  navigate('/admin/dashboard');

        }
        fetchLogs();
    }, []);

    useEffect(() => {
        handleFilter(new Event('submit'));
    }, [filters]);

    const handleChange = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value
        });
    };

    const handleFilter = (e) => {
        e.preventDefault();

        const { username, status, start_date, end_date } = filters;

        const filtered = allLogs.filter(log => {
            const logDate = new Date(log.created_at);

            const matchesUsername = !username || (log.user?.name || '').toLowerCase().includes(username.toLowerCase());
            const matchesStatus = !status || log.status === status;
            const matchesStartDate = !start_date || logDate >= new Date(start_date);
            const matchesEndDate = !end_date || logDate <= new Date(end_date);

            return matchesUsername && matchesStatus && matchesStartDate && matchesEndDate;
        });

        setFilteredLogs(filtered);
    };

    return (
        <div className="login-logs-container">
            <h2 className="title">Login Logs</h2>

            <form className="filter-form" onSubmit={handleFilter}>
                <input
                    type="text"
                    name="username"
                    placeholder="Username"
                    value={filters.username}
                    onChange={handleChange}
                />
                <select name="status" value={filters.status} onChange={handleChange}>
                    <option value="">All Types</option>
                    <option value="login">Login</option>
                    <option value="logout">Logout</option>
                </select>
                <input
                    type="date"
                    name="start_date"
                    value={filters.start_date}
                    onChange={handleChange}
                />
                <input
                    type="date"
                    name="end_date"
                    value={filters.end_date}
                    onChange={handleChange}
                />
                <button type="submit">Filter</button>
            </form>

            <div className="table-wrapper">
                <table className="logs-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>User</th>
                            <th>IP Address</th>
                            <th>Status</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredLogs.length === 0 ? (
                            <tr><td colSpan="5">No records found</td></tr>
                        ) : (
                            filteredLogs.map((log) => (
                                <tr key={log.id}>
                                    <td>{log.id}</td>
                                    <td>{log.user?.name ?? 'Unknown'}</td>
                                    <td>{log.ip_address}</td>
                                    <td className={log.status === 'login' ? 'status-success' : 'status-failed'}>
                                        {log.status}
                                    </td>
                                    <td>{new Date(log.created_at).toLocaleString()}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LoginLogs;
